import request from "@/utils/request";
import { ouchnCustom } from "@/service";

// 查询最新、热门、销量专题列表
export function ListSpecial(query) {
  return request({
    url: ouchnCustom + "/web/subject/querySubjectList",
    method: "get",
    params: query,
  });
}

// 查询专题详情——详细信息
export function specialDetailInfo(subjectId) {
  return request({
    url: ouchnCustom + "/web/subject/getSubjectDetails?subjectId=" + subjectId,
    method: "get",
  });
}

// 查询专题详情——商品列表
export function listResource(query) {
  return request({
    url: ouchnCustom + "/web/subject/getGoodsBySubjectId",
    method: "get",
    params: query,
  });
}

// 查询专题详情——评价列表
export function listEvaluate(query) {
  return request({
    url: ouchnCustom + "/web/subject/listEvaluate",
    method: "get",
    params: query,
  });
}
// 查询专题详情——推荐专题
export function recommendSubject(subjectId) {
  return request({
    url:
      ouchnCustom + "/web/subject/getRecomSubjectList?subjectId=" + subjectId,
    method: "get",
  });
}
// 查询专题详情——推荐商品
export function recommendGoods(subjectId) {
  return request({
    url: ouchnCustom + "/web/subject/getRecomGoodsList?subjectId=" + subjectId,
    method: "get",
  });
}

// 在线阅读epub——添加笔记
export function insertNote(data) {
  return request({
    url: ouchnCustom + "/web/api/note/addNote",
    method: "post",
    data: data,
  });
}

// 在线阅读epub——修改笔记
export function update(data) {
  return request({
    url: ouchnCustom + "/web/api/note/updateNote",
    method: "post",
    data: data,
  });
}

// 在线阅读epub——删除笔记
export function removeNoteById(noteId) {
  return request({
    url: ouchnCustom + "/web/api/note/deleteNote",
    method: "post",
    params: { noteId },
  });
}

// 根据资源文件id查询所有笔记
export function selectNoteListByFileId(filesId, type) {
  return request({
    url: ouchnCustom + "/web/api/note/getNoteInfo",
    method: "get",
    params: { filesId, type },
  });
}

// 我的书架跳转专题详情时查询专题的基本信息
export function selectSubjectBase(params) {
  return request({
    url: ouchnCustom + "/web/myResource/selectSubjectBase",
    method: "get",
    params: params,
  });
}
// 我的书架跳转专题详情时查询专题的商品列表
export function selectSubjectGoodsList(params) {
  return request({
    url: ouchnCustom + "/web/myResource/selectSubjectGoodsList",
    method: "get",
    params: params,
  });
}
// 我的书架跳转资源包详情时查询资源包的基本信息
export function selectBundleBase(params) {
  return request({
    url: ouchnCustom + "/web/myResource/selectBundleBase",
    method: "get",
    params: params,
  });
}
// 我的订单详情跳转资源包详情时查询资源包的基本信息
export function selectResourceBundleDetail(params) {
  return request({
    url: ouchnCustom + "/web/api/ocOrder/selectResourceBundleDetail",
    method: "get",
    params: params,
  });
}
// 我的书架跳转资源包详情时查询资源包的商品列表
export function selectBundleGoodsList(params) {
  return request({
    url: ouchnCustom + "/web/myResource/selectBundleGoodsList",
    method: "get",
    params: params,
  });
}
// 查看阅读文件地址和文件进度
export function selectFileLinkAndReadingLocation(data) {
  return request({
    url: ouchnCustom + "/web/read/selectFileLinkAndReadingLocationV2",
    method: "post",
    data: data,
  });
}
// 查看阅读文件地址和文件进度
export function decryptEpubHtml(data) {
  return request({
    url: ouchnCustom + "/web/read/decryptEpubHtml",
    method: "post",
    data: data,
  });
}
// 获取阅读时长
export function selectReadInfo(params) {
  return request({
    url: ouchnCustom + "/web/read/selectReadInfo",
    method: "get",
    params: params,
  });
}
// 获取调用阅读时长接口频率
export function selectTimeParameter(params) {
  return request({
    url: ouchnCustom + "/web/read/selectTimeParameter",
    method: "get",
    params: params,
  });
}
// 更新用户阅读时长
export function updateOcDownloadReading(data) {
  return request({
    url: ouchnCustom + "/web/read/updateOcDownloadReading",
    method: "post",
    data: data,
  });
}
// 更新阅读进度
export function updateOcReadSchedule(data) {
  return request({
    url: ouchnCustom + "/web/read/updateOcReadSchedule",
    method: "post",
    data: data,
  });
}
// 更新阅读进度
// export function updateOcReadSchedule(data) {
//   return request({
//     url:
//       ouchnCustom +
//       "/web/read/updateOcReadSchedule?fileId=" +
//       data.fileId +
//       "&" +
//       "readingLocation=" +
//       data.readingLocation +
//       "&" +
//       "schedule=" +
//       data.schedule,
//     method: "post",
//     // data: data,
//   });
// }
// 获取转换后的图片路径（pdf在线阅读）
export function getConvertImagePath(params) {
  return request({
    url: ouchnCustom + "/getImagePathList",
    // url: '/ouchn-customapi-xiemeng/getImagePathList',
    method: "get",
    params: params,
  });
}

// 获取征订系统阅读路径
export function getFileLink(data) {
  return request({
    // url: ouchnCustom + '/web/read/getSolicitUserFileLinkAndIsHavingPermissions',
    url:
      ouchnCustom +
      "/web/read/getSolicitUserFileLinkAndIsHavingPermissions?goodsId=" +
      data.goodsId +
      "&goodsFileId=" +
      data.filesId +
      "&fileType=" +
      data.fileType,
    method: "get",
    // data: data
  });
}

// 查询是否访问本地系统阅读权限
export function getFileLinkPermissions(data) {
  return request({
    // url: ouchnCustom + '/web/read/getSolicitUserFileLinkAndIsHavingPermissions',
    url:
      ouchnCustom +
      "/web/read/getFileLinkAndIsHavingPermissions?goodsId=" +
      data.goodsId +
      "&goodsFileId=" +
      data.filesId +
      "&fileType=" +
      data.fileType +
      "&sysId=" +
      data.sysId,
    method: "get",
    // data: data
  });
}
